import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";

export const selectAnnouncement = (state: RootState) => state.announcement;

export const selectAnnouncementChannel = createSelector(
  selectAnnouncement,
  (substate) => substate?.channel,
);

export const selectAnnouncementMessage = createSelector(
  selectAnnouncement,
  (substate) => substate?.message,
);
export const selectAnnouncementSender = createSelector(
  selectAnnouncement,
  (substate) => substate?.sender,
);
export const selectAnnouncementSentAt = createSelector(
  selectAnnouncement,
  (substate) => substate?.sentAt,
);
export const selectAnnouncementIsNew = createSelector(
  selectAnnouncement,
  (substate) => substate?.isNew,
);
export const selectAnnouncementIsShowSendDialog = createSelector(
  selectAnnouncement,
  (substate) => substate?.isShowSendDialog,
);
